import { render, staticRenderFns } from "./data-Pyramid.vue?vue&type=template&id=4de8f0cb&scoped=true&"
import script from "./data-Pyramid.vue?vue&type=script&lang=js&"
export * from "./data-Pyramid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de8f0cb",
  null
  
)

export default component.exports